var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';
export var Colors = {
    AZUL_GOV: '#0048B6',
    SECONDARY_GOV: '#19857b',
    AMARELO_GOV: '#FDB913',
    VERMELHO_GOV: '#D32F2F',
    VERDE_GOV: '#2E7D32',
    BRANCO_GOV: '#FFFFFF',
};
export var appTheme = createTheme({
    palette: {
        primary: {
            main: Colors.AZUL_GOV,
        },
        secondary: {
            main: Colors.SECONDARY_GOV,
        },
        error: {
            main: red.A400,
        },
        background: {
            default: 'rgba(255, 255, 255, 1)',
            paper: 'rgba(255, 255, 255, 1)',
        },
        text: {
            primary: 'rgba(0, 0, 0, 0.87)',
            secondary: 'rgba(0, 0, 0, 0.6)',
        },
    },
    typography: {
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        h1: {
            fontSize: '103px',
            fontWeight: 300,
            letterSpacing: '-1.545px',
        },
        h2: {
            fontSize: '32px',
            fontWeight: 500,
            letterSpacing: '-0.32px',
        },
        h6: {
            fontSize: '20px',
            fontWeight: 500,
            letterSpacing: '0.15px',
        },
        subtitle1: {
            fontSize: '17px',
            fontWeight: 500,
            letterSpacing: '0.15px',
        },
        caption: {
            fontSize: '0.8rem',
            fontWeight: 400,
            lineHeight: '1em',
            letterSpacing: '0.4px',
        },
        body1: {
            fontSize: '17px',
            fontWeight: 400,
            letterSpacing: '0.5px',
        },
        body2: {
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0.5px',
            color: '#666666',
        },
        button: {
            fontSize: '14px',
            fontWeight: 500,
            letterSpacing: '0.4px',
            textTransform: 'none',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: '600',
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                size: 'small',
                slotProps: {
                    inputLabel: { shrink: true },
                },
            },
            styleOverrides: {
                root: {
                    fontSize: '0.875rem',
                },
            },
        },
        MuiSelect: {
            defaultProps: {
                size: 'small',
            },
            styleOverrides: {
                select: {
                    padding: '8px 12px',
                },
            },
        },
        MuiFormControl: {
            defaultProps: {
                size: 'small',
            },
        },
        MuiInputLabel: {
            defaultProps: {
                shrink: true,
            },
            styleOverrides: {
                root: {},
            },
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    padding: '8px 12px',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: function (_a) {
                    var theme = _a.theme;
                    return (__assign({}, theme.typography.h2));
                },
                head: function (_a) {
                    var theme = _a.theme;
                    return (__assign({}, theme.typography.subtitle1));
                },
                body: function (_a) {
                    var theme = _a.theme;
                    return (__assign({}, theme.typography.body1));
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                primary: function (_a) {
                    var theme = _a.theme;
                    return (__assign({}, theme.typography.body1));
                },
                secondary: function (_a) {
                    var theme = _a.theme;
                    return (__assign({}, theme.typography.body1));
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: '4px',
                    margin: 0,
                    backgroundColor: '#EAEFF9',
                    height: '22px',
                    fontSize: '14px',
                },
            },
        },
    },
});
